import { useDarkMode } from '../../hooks/useDarkMode';

interface DarkModeToggleProps {
  isScrolled?: boolean;
  isHomePage?: boolean;
}

export default function DarkModeToggle({ isScrolled, isHomePage }: DarkModeToggleProps) {
  const { isDark, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      title={isDark ? 'ライトモードに切り替え' : 'ダークモードに切り替え'}
      aria-label={isDark ? 'ライトモードに切り替え' : 'ダークモードに切り替え'}
      className={`p-2 rounded-lg transition-all cursor-pointer ${
        isScrolled || !isHomePage
          ? 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
          : 'text-white hover:bg-white/20'
      }`}
    >
      <div className="relative w-6 h-6 flex items-center justify-center">
        {/* 太陽アイコン（ライトモード時） */}
        <i
          className={`ri-sun-line text-xl absolute transition-all duration-300 ${
            isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'
          }`}
        ></i>
        {/* 月アイコン（ダークモード時） */}
        <i
          className={`ri-moon-line text-xl absolute transition-all duration-300 ${
            isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'
          }`}
        ></i>
      </div>
    </button>
  );
}
